<div [ngClass]="computedClasses" class="w-full">
  <ng-content></ng-content>
</div>

